<script setup lang="ts">
import { ChevronIcon } from '@metapic-apps/shared'
import { ElDropdown, ElDropdownItem, ElDropdownMenu, ElIcon } from 'element-plus'
import { computed } from 'vue'

import type { PerformanceChartMetric } from '@/lib/types/performance.types'

const metric = defineModel<PerformanceChartMetric>({ required: true })
const METRIC_LABELS: Record<PerformanceChartMetric, string> = {
  unique_views: 'Unique views',
  media_value: 'Media value',
  clicks: 'Clicks',
  order_value: 'Order value',
  number_of_orders: 'Orders',
  revenue_potential: 'Revenue potential',
}
const activeLabel = computed(() => METRIC_LABELS[metric.value])
const handleCommand = (value: PerformanceChartMetric) => {
  metric.value = value
}
</script>
<template>
  <ElDropdown trigger="click" @command="handleCommand">
    <button type="button" class="metric-select">
      {{ activeLabel }}
      <ElIcon :size="18"><ChevronIcon /></ElIcon>
    </button>
    <template #dropdown>
      <ElDropdownMenu>
        <ElDropdownItem v-for="(label, value) in METRIC_LABELS" :key="value" :command="value" :class="{ 'is-active': value === metric }">
          {{ label }}
        </ElDropdownItem>
      </ElDropdownMenu>
    </template>
  </ElDropdown>
</template>
<style scoped lang="scss">
.metric-select {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--black);
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
}
</style>
